module.exports = __webpack_public_path__ + "img/rate3.0a173f2c.png";